module.exports = {
    brandInfo: {
        phoneNumber: "16132302458",
        contactEmail: "info@thetrucktown.com",
        address: `5831 Perth St. Richmond, ON K0A 3H0`,
        copyright: `© ${new Date().getFullYear()} TruckTown`,
        defaultCampaignId: "245",
    },

    images: {
        icon: "images/TruckTownLogo.png",
        logo: "images/TruckTownLogo.png",
    },

    project: "trucktown-credit-application",
    name: "TruckTown",
    description: `Get the best rates`,

    siteUrl: "https://www.thetrucktown.com/",
    homeUrl: "/",
    termsUrl: "/terms_of_use",
    privacyPolicyUrl: "/privacy_policy",
    successUrl: "/success",

    hideSuccessCtas: true,
    twilioVerifyMethods: ["sms"],
};